import { yupNumber, yupObject } from 'shared/utils/YupUtils';
import { InferType } from 'yup';

export type CarrierEditDTO = InferType<typeof carrierEditSchema>;
export const carrierEditSchema = yupObject({
  largest_trailer_capacity: yupNumber()
    .min(1, 'Trailer capacity can not be less than 1')
    .max(11, 'Trailer capacity can not be more than 11'),
});
